import { render, staticRenderFns } from "./confs.vue?vue&type=template&id=5529b005&scoped=true&"
import script from "./confs.vue?vue&type=script&lang=js&"
export * from "./confs.vue?vue&type=script&lang=js&"
import style0 from "./confs.vue?vue&type=style&index=0&id=5529b005&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529b005",
  null
  
)

export default component.exports